<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Audit {{getDatasetDisplayType(recordData.dataSetType)}}
        <span v-if="showAutoSave" class="autosave-notification">
          <span>
            <span class="fa fa-refresh rotate" style="font-size: 17px"></span>
          </span>
          &nbsp;Saving...
        </span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"><i class="fa fa-dashboard"></i> Home</a>
        </li>
        <li class="active">{{getDatasetDisplayType(recordData.dataSetType)}} Audit</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="file-display-div">
              <strong>File name: </strong>{{recordData.fileName}}
              <br/>
              <strong>Gender count: </strong> Women - {{womenCount}}, Men - {{menCount}}
            </div>
            <div >
              <div class="col-xs-12 col-md-12 col-lg-12 audit-symptoms-table">
                  <div v-if="recordData.dataSetType !== 'chat-intent'">
                    <vue-good-table
                    styleClass="vgt-table good-table condensed striped"
                    :columns="getColumns()"
                    :rows="dataSetData"
                    :pagination-options="{
                        enabled: true,
                        perPage: 15,
                        perPageDropdown: [10, 15, 20, 50, 100]
                    }">
                      <div slot="emptystate"><nv-empty-state icon="fa-heartbeat" title="No records found" hint="Try changing the filters." /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />
                        <span v-if="props.column.field == 'manual_classifier'" style="max-width: 33%">
                             <treeselect placeholder="--Choose or Enter tag--"
                                  :multiple="true" 
                                  :defaultOptions="true"
                                  :load-options="loadOptions" 
                                  :async="true"
                                  :clearOnSelect="true"
                                  id="tag"
                                  v-model="recordData.dataSet[props.row.tableIndex].manual_classifier"
                                  search-nested
                                  :cacheOptions="false"
                                  @select="addNewSource($event, props)"
                                  @input="onTagChange(props)"
                                  @close="autoSaveDataSet"
                                  @open="handleOpen"
                                  >
                                <div slot="value-label" slot-scope="{ node }">{{ node.raw.customlabel }}</div>
                          </treeselect>
                        </span>
                        <span v-else-if="props.column.field == 'action'" style="white-space:pre-line">{{getActionText(props)}}</span>
                        <span v-else style="white-space: pre-line;word-break: break-word; text-align: left;float: left;">{{props.formattedRow[props.column.field]}}</span>
                      </template>
                    </vue-good-table>
                  </div>
                  <div v-else class="audit-chat-intent-table  ">
                    <vue-good-table
                    styleClass="vgt-table good-table condensed striped"
                    :columns="chatIntentColumns"
                    :rows="dataSetData"
                    max-height="74vh"
                    :fixed-header="true"
                    :pagination-options="{
                        enabled: true,
                        perPage: 15,
                        perPageDropdown: [10, 15, 20, 50, 100]
                    }">
                      <div slot="emptystate"><nv-empty-state icon="fa-comments-o" title="No records found" hint="Try changing the filters." /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />
                        <span v-if="props.column.field == 'manual_classifier'" style="max-width: 33%">
                          <div class="row chat-intent-classifier">
                              <strong style="white-space: pre;">Classifier: </strong>
                                <treeselect placeholder="--Choose or Enter tag--"
                                  :options="referralSource"
                                  v-model="recordData.dataSet[props.row.tableIndex].manual_classifier"
                                  search-nested
                                  @select="addNewSource($event, props)"
                                  @input="changeClassifier(recordData.dataSet[props.row.tableIndex])"
                                  >
                                <div slot="value-label" slot-scope="{ node }">{{ node.raw.customlabel }}</div>
                          </treeselect>
                          </div>
                          <div class="row chat-intent-classifier">
                            <strong style="white-space: pre;">Response: </strong> {{recordData.dataSet[props.row.tableIndex].response ? recordData.dataSet[props.row.tableIndex].response : ' No response'}}
                          </div>
                        </span>
                        <span v-else-if="props.column.field == 'action'" style="text-align: start;">
                                          <div class="row">
                                              <div class="col-md-12 col-lg-12 col-xs-12">
                                                <label class="checkbox-inline">
                                                  <input disabled type="checkbox" name="autoaccepttnc" id="autoaccepttnc" v-model="recordData.dataSet[props.row.tableIndex].action.wrong_classification">Wrong Classification
                                                </label>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col-md-12 col-lg-12 col-xs-12">
                                                <label class="checkbox-inline">
                                                <input type="checkbox" name="customMessages" id="customMessages" v-model="recordData.dataSet[props.row.tableIndex].action.bad_response" @change="autoSaveDataSet">Bad Response
                                                </label>
                                              </div>
                                          </div>
                        </span>
                        <span v-else style="white-space: pre-line; word-break: break-word; text-align: left;float: left;">{{props.formattedRow[props.column.field]}}</span>
                      </template>
                    </vue-good-table>
                  </div>
              </div>

            </div>
              <span v-if="showAutoSave" class="autosave-notification-bottom">
                <span>
                  <span class="fa fa-refresh rotate" style="font-size: 17px"></span>
                </span>
                &nbsp;Saving...
              </span>
                <div class="audit-save-btn">
                  <router-link :to="`/auditing/${recordData.dataSetType}`">
                    <button type="button" class="btn btn-primary" style="margin: 30px 0px;">Go back</button> 
                  </router-link>
                  <button type="button" class="btn btn-primary" style="margin: 30px 0px;" @click="updateDataSet">Submit Actions</button> 
              </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>
</template>

<script>
import api from '../../../utils/api'
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import { getDatasetDisplayType } from './helpers'

export default {
  name: 'auditing',
  components: {
  },
  data () {
    return {
      showAutoSave: false,
      timeoutCounter: 0,
      isDropdownOpen: false,
      recordData: {},
      dataSetData: [],
      dataSetId: '',
      referralSource: [],
      getDatasetDisplayType: getDatasetDisplayType,
      womenCount: 0,
      menCount: 0,
      loading: true,
      symptomsColumns: [
        {
          label: 'User Message',
          field: 'symptoms',
          sortable: false
        },
        {
          label: 'Interpretation',
          field: 'manual_classifier',
          sortable: false
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false
        }
      ],
      medicationColumns: [
        {
          label: 'User Message',
          field: 'medications',
          sortable: false
        },
        {
          label: 'Interpretation',
          field: 'manual_classifier',
          sortable: false
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false
        }
      ],
      chatIntentColumns: [
        {
          label: 'Bot Prompt',
          field: 'bot_prompt',
          sortable: false
        },
        {
          label: 'User Message',
          field: 'message_text',
          sortable: false
        },
        {
          label: 'Interpretation',
          field: 'manual_classifier',
          sortable: false
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false
        }
      ]
    }
  },
  mounted () {
    if (this.$route.path) {
      this.dataSetId = this.$route.path.split('/').pop()
    }
    this.loading = false
    this.getDataSetById()
  },
  methods: {
    changeClassifier (data) {
      if ((data.classifier_decision === data.manual_classifier) || (!data.classifier_decision && !data.manual_classifier)) {
        data.action.wrong_classification = false
      } else {
        data.action.wrong_classification = true
      }
      this.autoSaveDataSet()
    },
    getActionText (props) {
      return this.recordData.dataSet[props.row.tableIndex].action
    },
    getColumns () {
      if (this.recordData.dataSetType === 'symptoms') {
        return this.symptomsColumns
      } else if (this.recordData.dataSetType === 'medications') {
        return this.medicationColumns
      }
      return []
    },
    addNewSource (event) {
      if (event.label.includes('click to add new tag') && !this.referralSource.find(item => item.customlabel.toLowerCase() === event.customlabel.toLowerCase())) {
        this.referralSource.push({id: event.id, label: `${event.customlabel} (Recently Added)`, customlabel: event.customlabel})
        this.addAuditTag(event.customlabel)
      }
    },
    handleOpen () {
      this.isDropdownOpen = true
    },
    onTagChange (props) {
      if (props) {
        const addedItems = this.recordData.dataSet[props.row.tableIndex].manual_classifier.filter(item => !this.recordData.dataSet[props.row.tableIndex].derived_classifier.includes(item))
        const removedItems = this.recordData.dataSet[props.row.tableIndex].derived_classifier.filter(item => !this.recordData.dataSet[props.row.tableIndex].manual_classifier.includes(item))

        let actionText = ''
        if (addedItems.length && removedItems.length) {
          actionText = actionText + `Added: ${addedItems.join(', ')} \n Removed: ${removedItems.join(', ')}`
        } else if (addedItems.length) {
          actionText = actionText + `Added: ${addedItems.join(', ')}`
        } else if (removedItems.length) {
          actionText = actionText + `Removed: ${removedItems.join(', ')}`
        } else {
          actionText = 'None'
        }
        if (actionText) this.recordData.dataSet[props.row.tableIndex].action = actionText
      }
      if (!this.isDropdownOpen && !this.recordData.dataSet[props.row.tableIndex].manual_classifier.length) {
        this.autoSaveDataSet()
      }
      this.dataSetData = JSON.stringify(this.recordData.dataSet)
    },
    addItemToArray (item) {
      if (!this.referralSource.find(a => a.id && a.id.toLowerCase() === item)) {
        this.referralSource.push({id: item, label: `${item}`, customlabel: item})
      }
    },
    addItemsToArray (items) {
      items.forEach(item => {
        if (item) this.addItemToArray(item)
      })
    },
    getAuditTags (dataSetType) {
      api.buildRequest(`/audit/tag/list`, 'POST', {dataSetType: dataSetType})
          .then(response => {
            if (response.status === 200) {
              response.data.payload.tags.forEach(item => {
                this.addItemToArray(item.tag)
              })
            } else {
              this.$swal({
                type: 'error',
                text: response.data.payload.message
              })
            }
          }).catch((err) => {
            this.$swal({
              type: 'error',
              text: err.response ? err.response.data.payload.message : 'An error occurred'
            })
          })
    },
    addAuditTag (tag) {
      api.buildRequest(`/audit/tag`, 'POST', {tag: tag.toLowerCase(), dataSetType: this.recordData.dataSetType})
          .then(response => {
            if (response.status !== 200) {
              this.$swal({
                type: 'error',
                text: response.data.payload
              })
            }
          }).catch(({ response }) => {
            this.$swal({
              type: 'error',
              text: response ? response.data.payload : 'An error occurred'
            })
          })
    },
    updateGenderCount (item) {
      if (item.gender === 'woman') this.womenCount++
      else if (item.gender === 'man') this.menCount++
    },
    getDataSetById () {
      this.loading = true
      api.buildRequest(`/audit/audit-data-set/${this.dataSetId}`, 'GET')
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.recordData = response.data.payload
              this.dataSetData = this.recordData.dataSet
              this.getAuditTags(this.recordData.dataSetType)
              this.recordData.dataSetType !== 'chat-intent' && this.recordData.dataSet && this.recordData.dataSet.forEach((item, index) => {
                this.updateGenderCount(item)
                item.tableIndex = index
                if (!item.manual_classifier || (JSON.stringify(item.derived_classifier) === JSON.stringify(item.manual_classifier))) {
                  item.manual_classifier = item.derived_classifier ? JSON.parse(JSON.stringify(item.derived_classifier)) : []
                  this.addItemsToArray(item.manual_classifier)
                  item.action = 'None'
                } else {
                  this.addItemsToArray(item.manual_classifier)
                }
              })
              this.recordData.dataSetType === 'chat-intent' && this.recordData.dataSet && this.recordData.dataSet.forEach((item, index) => {
                this.updateGenderCount(item)
                item.tableIndex = index
                if (!(item.manual_classifier || item.manual_classifier === '') || (JSON.stringify(item.classifier_decision) === JSON.stringify(item.manual_classifier))) {
                  item.manual_classifier = item.classifier_decision ? item.classifier_decision : null
                  if (item.manual_classifier) this.addItemsToArray([item.manual_classifier])
                  if (!item.action) {
                    item.action = {
                      wrong_classification: false,
                      bad_response: false
                    }
                  }
                } else {
                  if (item.manual_classifier === '') item.manual_classifier = null
                  this.addItemsToArray([item.manual_classifier])
                }
              })
            } else {
              console.log('error ')
              this.$swal({
                type: 'error',
                text: 'An error occurred'
              })
            }
          }).catch((response) => {
            this.loading = false
            console.log('error ', response)
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    autoSaveDataSet () {
      this.isDropdownOpen = false
      this.timeoutCounter++
      let cloneRecordData = JSON.parse(JSON.stringify(this.recordData))
      cloneRecordData.dataSet.forEach(item => {
        delete item.tableIndex
        if (cloneRecordData.dataSetType === 'chat-intent') item.manual_classifier = item.manual_classifier || ''
      })
      this.showAutoSave = true
      setTimeout(() => {
        --this.timeoutCounter
        if (!this.timeoutCounter) this.showAutoSave = false
      }, 2000)
      api.buildRequest(`/audit/audit-data-set/${this.dataSetId}`, 'PUT', cloneRecordData)
          .then(response => {
            if (response.status !== 200) {
              this.$swal({
                type: 'error',
                text: 'An error occurred during autosave'
              })
            }
          }).catch(({ response }) => {
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred during autosave'
            })
          })
    },
    updateDataSet () {
      this.loading = true
      let cloneRecordData = JSON.parse(JSON.stringify(this.recordData))
      cloneRecordData.dataSet.forEach(item => {
        delete item.tableIndex
        if (cloneRecordData.dataSetType === 'chat-intent') item.manual_classifier = item.manual_classifier || ''
      })
      api.buildRequest(`/audit/audit-data-set/${this.dataSetId}`, 'PUT', cloneRecordData)
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.$swal({
                type: 'success',
                text: 'Data set updated successfully'
              })
            } else {
              this.$swal({
                type: 'error',
                text: 'An error occurred'
              })
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    loadOptions ({ action, searchQuery, callback }) {
      if (!searchQuery) {
        callback(null, this.referralSource)
      }
      if (action === ASYNC_SEARCH && searchQuery) {
        const options = []
        if (!this.referralSource.find(item => item.customlabel.toLowerCase() === searchQuery.toLowerCase())) {
          options.push({id: searchQuery, label: `${searchQuery} (click to add new tag)`, customlabel: searchQuery})
        }
        this.referralSource.forEach(source => {
          if (source.label.toLowerCase() === searchQuery.toLowerCase()) {
            options.pop()
            options.push(source)
          } else if (source.label.toLowerCase().includes(searchQuery.toLowerCase())) {
            options.push(source)
          }
        })
        callback(null, options)
      }
    }
  }
}
</script>

<style scoped>
.value {
  font-weight: bold;
}
input[type="file"] {
  display: none;
}
.box-body {
  min-height: calc(100vh - 171px);
}
.form-loader img {
  width: 30px;
  height: 30px;
}
.btn-import-dataset {
  margin-bottom: 15px;
  margin-right: 15px;
}
.file-display-div {
  font-size: 20px;
  margin-top: 10px;
  margin-left: 15px;
  margin-bottom: 10px;
}
.audit-save-btn {
  text-align: right;
  margin-right: 15px;
}
.chat-intent-classifier {
  display: flex;
  margin: 10px 20px;
  align-items: center;
}
</style>
<style>
.audit-symptoms-table .vue-treeselect__multi-value {
  margin-left: 5px;
}
td .vgt-left-align {
  text-align: left !important;
}
.audit-symptoms-table .vgt-table thead th {
  width: 33% !important;
}
.audit-chat-intent-table .vgt-table thead th {
  width: 25% !important;
}
.autosave-notification {
  font-size: initial;
  background-color: #ebeff500;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s;
  margin-left: 25px;
}

.autosave-notification-bottom {
  font-size: initial;
  background-color: #ebeff500;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s;
  margin-left: 25px;
  position: relative;
  top: 167px;
  left: 255px;
}

.autosave-notification.show, .autosave-notification-bottom.show{
  opacity: 1;
}

.autosave-notification.hide, .autosave-notification-bottom.hide{
  opacity: 0;
}
.vgt-fixed-header {
  width: 99% !important;
}
.vgt-responsive {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// audit.vue?1bf36325